<template lang="html">
   <div class="view-customer">
      <div class="row justify-content-center" v-if="customer">
         <div class="col-12 col-md-10 col-lg-9" v-if="customer.customerType === 'B2C'">
            <div class="summary-box" v-for="card in customer.cards">
               <div class="item clearfix">
                  <div class="key l">CARD HOLDER NAME</div>
                  <div class="value r">{{card.name}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">ID/PASSPORT NUMBER</div>
                  <div class="value r">{{card.idNumber}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">MOBILE NUMBER</div>
                  <div class="value r">{{card.mobileNo.code.callingCode+''+card.mobileNo.mobile}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">EMAIL ADDRESS</div>
                  <div class="value r tx-lowercase">{{card.email}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">DEPOSIT</div>
                  <div class="value r tx-lowercase">{{card.deposit}}</div>
               </div>
               <div class="item clearfix" v-if="customer.station">
                  <div class="key l">PICKUP STATION</div>
                  <div class="value r">{{customer.station.name}} - {{customer.station.county}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">PROMO CODE</div>
                  <div class="value r">{{customer.promoCode || '-'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">CAR REGISTRATION NUMBER</div>
                  <div class="value r">{{card.vehicleReg || '-'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">SMS ALERTS</div>
                  <div class="value r">{{card.sms ? 'YES' : 'NO'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">Millage Input</div>
                  <div class="value r">{{card.millageInput ? 'YES' : 'NO'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">Driver Code</div>
                  <div class="value r">{{card.driverCode ? 'YES' : 'NO'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">PRODUCT RESTRICTION</div>
                  <div class="value r">{{card.productRestriction}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">ZONE RESTRICTION</div>
                  <div class="value r">{{card.authorizedZones}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">DAYS OF USE</div>
                  <div class="value r">{{card.daysOfUse}}</div>
               </div>
            </div>
         </div>
         <div class="col-12 col-md-10 col-lg-9" v-if="customer.customerType === 'B2B'">
            <div class="summary-box" v-for="card in customer.cards">
               <div class="item clearfix">
                  <div class="key l">COMPANY NAME</div>
                  <div class="value r">{{customer.companyName}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">COMPANY REGISTRATION NO.</div>
                  <div class="value r">{{customer.companyRegistrationNo}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">MOBILE NUMBER</div>
                  <div class="value r">{{card.mobileNo.code.callingCode+''+card.mobileNo.mobile}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">EMAIL ADDRESS</div>
                  <div class="value r tx-lowercase">{{card.email}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">DEPOSIT</div>
                  <div class="value r tx-lowercase">{{card.deposit}}</div>
               </div>
               <div class="item clearfix" v-if="customer.station">
                  <div class="key l">PICKUP STATION</div>
                  <div class="value r">{{customer.station.name}} - {{customer.station.county}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">CARD HOLDER NAME</div>
                  <div class="value r">{{card.name}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">ID/PASSPORT NUMBER</div>
                  <div class="value r">{{card.idNumber}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">CAR REGISTRATION NUMBER</div>
                  <div class="value r">{{card.vehicleReg || '-'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">SMS ALERTS</div>
                  <div class="value r">{{card.sms ? 'YES' : 'NO'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">Millage Input</div>
                  <div class="value r">{{card.millageInput ? 'YES' : 'NO'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key l">Driver Code</div>
                  <div class="value r">{{card.driverCode ? 'YES' : 'NO'}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key">PRODUCT RESTRICTION</div>
                  <div class="value mt-2">{{card.productRestriction}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key">ZONE RESTRICTION</div>
                  <div class="value mt-2">{{card.authorizedZones}}</div>
               </div>
               <div class="item clearfix">
                  <div class="key">DAYS OF USE</div>
                  <div class="value mt-2">{{card.daysOfUse}}</div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data(){
      return {
         customer: []
      }
   },
   created(){
      EventBus.$emit('loader:show', true)
   },
   methods: {
      handleActions(){

      }
   },
   async mounted(){
      this.customer = await $session.get('selectedCustomer')
      console.log(this.customer.cards)
      EventBus.$emit('loader:show', false)
   }
}
</script>

<style lang="scss">
   .view-customer{
      .summary-box {
         background: $white;
         padding: 30px 20px;
         border-radius: 10px;
         margin: 30px 0;
         border: solid 1px $border-grey;
      
         .item {
            padding: 7px 15px;
            border-bottom: solid 2px $text-grey;
            text-transform: uppercase;

            .key {
               text-align: left;
            }
            .value {
               font-family: $font-black;
               font-size: 13px;
            }
         }
         .item:first-child {
            border-top: solid 2px $text-grey;
         }
         .item:nth-child(even) {
            background: rgba(grey, 0.25);
         }
         .grey-input {
            border: 0;
            border-radius: 0;
            background: rgba($color: gray, $alpha: 0.4);
            padding: 6px 15px;
         }
         .input-text {
            font-family: $font;
            margin: 7px 10px 0 0;
         }
         .mpesa-box{
            text-align: right;
            font-size: 40px;
            margin: 0 0 10px 0;
         }
      }
   }
</style>